import { useUserContext } from "@/features/user/contexts/useUserContext";
import { NftInfo } from "@/generated/generated-hooks";

export const useEth721Ownership = (asset: NftInfo) => {
  const { user } = useUserContext();

  if (!user?.walletAccount || !asset?.owner)
    return { isNftOwner: false, isNftCreator: false };

  const isNftOwner = asset?.owner?.toLowerCase() === user?.walletAccount;
  const isNftCreator =
    asset?.initialOwner?.toLowerCase() === user?.walletAccount;

  return {
    isNftOwner,
    isNftCreator,
  };
};
